import type { FC } from 'react';

import Upload from '@crehana/compass.icons.outline/Upload';
import { boldFormatter, useTranslation } from '@crehana/i18n';
import File from '@crehana/icons/outline/File';
// biome-ignore lint/style/noRestrictedImports: legacy import, will be migrated
import { Col, colors, Row } from '@crehana/ui';

import CardContainer from '@/views/AdminDashboard/components/CardContainer';
import { useExcelImporterStepperContext } from '@/views/AdminDashboard/components/ExcelImporterStepper/context';
import FileInput from '@/views/AdminDashboard/components/FileInput';
import Instructions from '@/views/AdminDashboard/components/Instructions';

import ContextInjectedWrapper from '../ContextInjectedWrapper/ContextInjectedWrapper';

const { baseLighter, grayMain } = colors;

const Step1: FC = () => {
  const { t } = useTranslation();
  const {
    instructions,
    file,
    setFile,
    isUpdateTeams,
    shouldShow,
    fileUploadTourSelector,
    isDark,
    aditionalOptions,
    maxFileSizeKb,
    keyLocation,
  } = useExcelImporterStepperContext();

  const icon = isDark ? baseLighter : grayMain;

  return (
    <div className="flex flex-col items-center pb-20 w-full">
      {shouldShow(['step1', 'all']) && (
        <>
          <p className="tw-pt-5.6 tw-font-h4 tw-mb-0.4">{t('STEP_1_TITLE')}</p>
          <p className="tw-font-body4 text-base-lighter whitespace-pre-line text-center">
            {t('STEP_1_SUBTITLE', { formatter: boldFormatter })}
          </p>
        </>
      )}
      <div className="tw-bg-neutral-light-100 dark:tw-bg-elevation-dark-02 tw-w-full tw-px-4 tw-py-3.2 tw-rounded-1.6 tw-mt-4">
        <div
          className="tw-flex tw-w-full tw-mb-3.2 tw-justify-center"
          css={{ padding: '24px 10px 24px 10px' }}
        >
          <Instructions isDark={isDark} instructions={instructions} />
        </div>
        <Row className="w-full">
          <Col className="w-full" data-tour={fileUploadTourSelector}>
            <CardContainer
              isDark={isDark}
              title={t('STEP_1_INPUT_TITLE')}
              icon={<File color={icon} size={24} />}
              actions={<ContextInjectedWrapper component={aditionalOptions} />}
              isLmsSendActive={keyLocation === 'Tracks'}
            >
              <FileInput
                file={file}
                isDark={isDark}
                onLoadFile={f => setFile(f)}
                labelMaxSize={t(
                  isUpdateTeams
                    ? 'STEP_1_INPUT_MAX_UPDATE'
                    : 'STEP_1_INPUT_MAX',
                )}
                maxSize={maxFileSizeKb}
                labelError={t('STEP_1_INPUT_LARGEST')}
                labelErrorExtension={t('MASSIVE_STEP_1_INPUT_INVALID_FORMAT')}
                labelErrorExtensionDesc={t(
                  'MASSIVE_STEP_1_INPUT_INVALID_FORMAT_DESC',
                )}
                labelLoading={t('STEP_1_INPUT_LOADING')}
                labelReplaceFile={t('STEP_1_INPUT_UPDATE')}
                label={
                  <>
                    <p className="tw-text-link-s text-link-icon tw-mb-0.4">
                      <Upload size={20} className="tw-text-primary-light-500" />
                      {t('STEP_1_INPUT_HINT_2')}
                    </p>
                    <p className="tw-block md:tw-flex tw-items-center tw-text-neutral-light-700 tw-font-pop tw-text-1.2">
                      {t('STEP_1_INPUT_HINT_1')} {t('STEP_1_INPUT_HINT_3')}
                    </p>
                  </>
                }
              />
            </CardContainer>
          </Col>
        </Row>
      </div>
    </div>
  );
};

export default Step1;
